import { GET_PARK_RESULTS } from './action-types';
import { getRequestStatus } from '../../../requests/selectors';

// Selectors
export const parkResults = (state) => state.data.park.results.parkResults;

// Utils to be used by other selectors
export const [getIsLoading, getHasFailed, getErrorData] = getRequestStatus(GET_PARK_RESULTS);
export const getIsLoaded = (state, parkId) => !!parkResults(state)[parkId];
